import React from "react";
import {TableCell} from "@material-ui/core";
import clsx from "clsx";
import annulaReportClasses from "../../constants/annulaReportClasses";

function AnnualReportTableCell(
    {
        children,
        className,
        borderRight,
        borderLeft,
        ...props
    }
) {
    const classes = annulaReportClasses();

    return (
        <TableCell className={
            clsx( classes.tableCell, {
                [classes.tableCellBorderRight]: borderRight,
                [classes.tableCellBorderLeft]: borderLeft
            }, className)} {...props}>{children}</TableCell>);

}



export default AnnualReportTableCell;